import { createSlice } from '@reduxjs/toolkit';

const getInitialCart = (userId) => {
  try {
    const cartKey = userId ? `cart_${userId}` : 'cart_guest';
    const savedCart = typeof window !== 'undefined' ? localStorage.getItem(cartKey) : null;
    return savedCart ? JSON.parse(savedCart) : [];
  } catch (error) {
    console.error('Failed to parse cart from localStorage:', error);
    return [];
  }
};

const saveCartToLocalStorage = (cart, userId) => {
  try {
    const cartKey = userId ? `cart_${userId}` : 'cart_guest';
    localStorage.setItem(cartKey, JSON.stringify(cart));
  } catch (error) {
    console.error('Failed to save cart to localStorage:', error);
  }
};

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: [],
    userId: null,
  },
  reducers: {
    initializeCart: (state, action) => {
      const userId = action.payload;
      state.userId = userId;
      state.items = getInitialCart(userId);
    },
    addToCart: (state, action) => {
      const item = {
        ...action.payload,
        // Ensure required fields with defaults
        id: action.payload.id || `temp-id-${Date.now()}`,
        title: action.payload.title || 'Untitled Class',
        instructor: action.payload.instructor || 'Unknown Instructor',
        price: action.payload.price || action.payload.cost || 0,
        thumbnail: action.payload.thumbnail || '',
        education_class: action.payload.education_class || '',
        quantity: action.payload.quantity || 1,
        type: action.payload.type || 'class' // 'class' or 'subscription'
      };
      
      const existingItemIndex = state.items.findIndex(cartItem => cartItem.id === item.id);
      
      if (existingItemIndex >= 0) {
        // For classes, increment quantity
        if (item.type === 'class') {
          state.items[existingItemIndex].quantity += 1;
        }
        // For subscriptions, replace existing one (only one allowed)
        else {
          state.items[existingItemIndex] = item;
        }
      } else {
        state.items.push(item);
      }
      
      saveCartToLocalStorage(state.items, state.userId);
    },
    removeFromCart: (state, action) => {
      const id = action.payload;
      state.items = state.items.filter(item => item.id !== id);
      saveCartToLocalStorage(state.items, state.userId);
    },
    updateQuantity: (state, action) => {
      const { id, newQuantity } = action.payload;
      if (newQuantity < 1) return;
      
      const itemIndex = state.items.findIndex(item => item.id === id);
      if (itemIndex >= 0 && state.items[itemIndex].type === 'class') {
        state.items[itemIndex].quantity = newQuantity;
        saveCartToLocalStorage(state.items, state.userId);
      }
    },
    clearCart: (state) => {
      state.items = [];
      saveCartToLocalStorage(state.items, state.userId);
    },
    changeUser: (state, action) => {
      const newUserId = action.payload;
      // Save current user's cart before switching
      saveCartToLocalStorage(state.items, state.userId);
      state.userId = newUserId;
      state.items = getInitialCart(newUserId);
    },
  },
});

export const { 
  initializeCart,
  addToCart, 
  removeFromCart, 
  updateQuantity, 
  clearCart,
  changeUser,
} = cartSlice.actions;

export default cartSlice.reducer;